/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tumor-measurement.reducer';

export const TumorMeasurementDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tumorMeasurementEntity = useAppSelector(state => state.tumorMeasurement.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tumorMeasurementDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tumorMeasurement.detail.title">TumorMeasurement</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.id">Id</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.id}</dd>
          <dt>
            <span id="incidentDate">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.incidentDate">Incident Date</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.incidentDate}</dd>
          <dt>
            <span id="measurementValue">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.measurementValue">Measurement Value</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.measurementValue}</dd>
          <dt>
            <span id="measurementUnit">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.measurementUnit">Measurement Unit</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.measurementUnit}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.active">Active</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tumorMeasurement.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tumorMeasurementEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorMeasurement.measurementName">Measurement Name</Translate>
          </dt>
          <dd>{tumorMeasurementEntity.measurementName ? tumorMeasurementEntity.measurementName.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tumorMeasurement.tumor">Tumor</Translate>
          </dt>
          <dd>{tumorMeasurementEntity.tumor ? tumorMeasurementEntity.tumor.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tumor-measurement" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tumor-measurement/${tumorMeasurementEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TumorMeasurementDetail;
